import { customizedToast } from "../Utils/CustomizedToast/customizedToast";

export const permitionCheckerWithCustomToast = (
  permissionArray: string[],
  selectedArray: string[],
  canCheck: boolean,
  message: string
): boolean => {
  const lowercasePermissionArray = permissionArray.map((item) =>
    item.toLowerCase()
  );

  const result: boolean = selectedArray
    .map((item) => item.toLowerCase())
    .some((item) => lowercasePermissionArray.includes(item));

  if (!canCheck) return false;

  if (result === false) {
    customizedToast(message, "info");
  }
  return result;
};
